<template>
  <div
    class="max-w-md mx-auto bg-white rounded-3xl shadow-lg px-6 pt-10 pb-8 flex flex-col items-center text-center relative overflow-hidden"
  >
    <div class="absolute inset-0 pointer-events-none sending-background"></div>
    <div class="relative z-10 w-full">
      <div class="text-lg font-semibold text-gray-900 mb-1">
        {{ title }}
      </div>
      <div class="text-sm text-gray-500 mb-6">
        {{ subtitle }}
      </div>

      <div class="loading-dots" aria-hidden="true">
        <span class="loading-dot"></span>
        <span class="loading-dot"></span>
        <span class="loading-dot"></span>
      </div>

      <div
        class="bg-white rounded-2xl shadow-md px-5 py-4 mt-6 text-left inline-block w-full sending-fact-card"
      >
        <div class="text-xs font-semibold text-secondary tracking-wide mb-1">
          {{ $t('curious-fact') }}
        </div>
        <div
          class="text-sm text-gray-800 leading-relaxed min-h-[4rem] flex items-center"
        >
          <transition name="fact-fade" mode="out-in">
            <p :key="currentFactIndex">
              {{ currentPsychologyFact }}
            </p>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PsychologyFactLoader',
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      factCount: 13,
      currentFactIndex: 0,
      factsIntervalId: null,
    };
  },
  computed: {
    currentPsychologyFact() {
      return this.$t('psychology-fact-' + this.currentFactIndex);
    },
  },
  mounted() {
    this.startFactsRotation();
  },
  beforeUnmount() {
    this.stopFactsRotation();
  },
  methods: {
    startFactsRotation() {
      if (this.factCount === 0) return;
      if (this.factsIntervalId) return;

      this.currentFactIndex = Math.floor(Math.random() * this.factCount);

      this.factsIntervalId = setInterval(() => {
        if (this.factCount === 0) return;
        let nextIndex = Math.floor(Math.random() * this.factCount);
        if (this.factCount > 1) {
          while (nextIndex === this.currentFactIndex) {
            nextIndex = Math.floor(Math.random() * this.factCount);
          }
        }
        this.currentFactIndex = nextIndex;
      }, 5000);
    },
    stopFactsRotation() {
      if (this.factsIntervalId) {
        clearInterval(this.factsIntervalId);
        this.factsIntervalId = null;
      }
    },
  },
};
</script>

<style scoped>
.sending-background {
  background-image: radial-gradient(
      circle at 10% 20%,
      rgba(129, 140, 248, 0.15) 0,
      transparent 40%
    ),
    radial-gradient(
      circle at 80% 0,
      rgba(236, 72, 153, 0.1) 0,
      transparent 45%
    ),
    radial-gradient(
      circle at 50% 100%,
      rgba(168, 85, 247, 0.12) 0,
      transparent 40%
    );
}

.sending-fact-card {
  box-shadow: 0 10px 25px rgba(15, 23, 42, 0.08);
}

.loading-dots {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.5rem;
}

.loading-dot {
  width: 8px;
  height: 8px;
  border-radius: 9999px;
  background-color: #4b5563;
  animation: loading-bounce 1s infinite ease-in-out;
}

.loading-dot:nth-child(2) {
  animation-delay: 0.15s;
}

.loading-dot:nth-child(3) {
  animation-delay: 0.3s;
}

/* Smooth fade/slide transition between facts */
.fact-fade-enter-active,
.fact-fade-leave-active {
  transition: opacity 0.35s ease, transform 0.35s ease;
}

.fact-fade-enter-from,
.fact-fade-leave-to {
  opacity: 0;
  transform: translateY(4px);
}

@keyframes loading-bounce {
  0%,
  80%,
  100% {
    transform: translateY(0);
    opacity: 0.4;
  }
  40% {
    transform: translateY(-4px);
    opacity: 1;
  }
}
</style>

